const config = {
  fields: [],
  validate: null,
};

export default config;
